import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ChartData, ChartOptions } from 'chart.js';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { ControlPoint } from '../../bo/controlPoint';
import { Graphique } from '../../bo/graphique';
import { Projet } from '../../bo/projet';
import { TypeTir } from '../../bo/TypeTir';
import { VibrationLineChart } from '../../bo/vibration';
import { DateInterval, FonctionsService } from '../../services/fonctions-partagees.service';
import { TraductionService } from '../../services/traduction.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import { KeycloakUtilisateurService } from 'src/app/services/keycloak/keycloak-utilisateur.service';

export const VibrationGraphColors = [
  '#6994D5', '#FF8033', '#E53C68', '#4CC7BA', '#006D99', "#EB0080", '#A6038B', '#F27329', '#F25244', '#0D0D0D'
];

export const VibrationChartOption = {
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    legend: {
      position: 'bottom' as const,
      labels: { usePointStyle: true }
    }
  },
  elements: {
    point: {
      radius: 3
    },
    line: {
      tension: 0
    }
  },
  scales: {
    y: {
      id: "axeMms",
      display: true,
      title: {
        display: true,
        text: 'mm/s',
        font: {
          size: 14
        }
      },
      position: "left" as const,
      ticks: {
        beginAtZero: false,
        color: '#7E003F'
      }
    },
    x: {
      id: "axeX",
      type: 'time' as const,
      display: true,
      position: "bottom" as const,
      time: {
        unit: 'day' as const,
        round: 'day' as const,
        displayFormats: {
          day: 'MMM D'
        }
      }
    }
  }
};


@Component({
  selector: 'app-plot-vibration',
  templateUrl: './plot-vibration.component.html',
  styleUrls: ['./plot-vibration.component.scss'],
  standalone: false
})
export class PlotVibrationComponent implements OnInit {
  @ViewChild('modalNomGraph') modalNomGraph: ModalDirective;
  @ViewChild('modalDejaAjoute') modalDejaAjoute: ModalDirective;

  tabProjets: Projet[] = [];
  tabTypesTir: TypeTir[] = [];
  typeTirSelectionnees: TypeTir[] = [];
  ptControlSelectionnes: ControlPoint[] = [];
  traductions: string[] = [];
  echelleX = "Tir";
  minDate: string;
  maxDate: string;
  langueCourante: string;
  tabPeriodes: any[] = [];
  tabControlPoints: any[] = [];
  rangeStart: Date | null = null;
  rangeEnd: Date | null = null;
  refEchelles: any[] = [];
  tabEchelle: string[] = [];
  periodeSelectionnee: string;
  chartType = "";
  sauvChartParametre = "";
  chartParametre = "";
  tabDates: Date[] = [];
  showIcon = true;
  showError = false;

  lineChartData: ChartData;
  lineChartOptions: ChartOptions = VibrationChartOption;

  constructor(
    private readonly tradService: TraductionService,
    private readonly http: HttpService,
    private readonly utilService: UtilisateurService,
    private readonly route: ActivatedRoute,
    private readonly fonctionsService: FonctionsService,
    private readonly keycloakUtilisateurService: KeycloakUtilisateurService,
      ) {
    this.langueCourante = tradService.translate.currentLang;
    this.tradService.langueCourante$.subscribe(resultat => {
      this.langueCourante = resultat;
    });
    this.tradService.translate.get(['GLOBAL.TIR', 'GLOBAL.JOURS', 'GLOBAL.SEMAINE', 'GLOBAL.MOIS', 'GLOBAL.30JOURS', 'GLOBAL.7JOURS', 'GLOBAL.DERNIER_MOIS', 'GLOBAL.ANNEE_COURANTE', 'GLOBAL.12DERNIERS_MOIS']).subscribe(traduction => {
      this.traductions = traduction;
      this.refEchelles = [
        { nom: traduction['GLOBAL.TIR'], valeur: 'Tir' },
      ];
      this.tabEchelle = this.refEchelles;
      this.tabPeriodes = [{ nom: traduction["GLOBAL.30JOURS"], valeur: "30jours" }, { nom: traduction["GLOBAL.7JOURS"], valeur: "7jours" }, { nom: traduction["GLOBAL.DERNIER_MOIS"], valeur: "dernierMois" }
        , { nom: traduction["GLOBAL.ANNEE_COURANTE"], valeur: "anneeCourante" }, { nom: traduction["GLOBAL.12DERNIERS_MOIS"], valeur: "12Mois" }];
    });
  }

  ngOnInit() {
    var saveSiteId = this.utilService.currentSite().siteId;
    this.route.params.subscribe(() => {
      if (this.utilService.currentSite().siteId != saveSiteId) {
        saveSiteId = this.utilService.currentSite().siteId;
        this.clearAll();
      }
      this.http.get("Sites/" + this.utilService.currentSite().siteId + "/BlastTypes").subscribe((res: TypeTir[]) => {
        this.tabTypesTir = res;
      });

      this.http.get("Sites/" + this.utilService.currentSite().siteId + "/ControlPoints").subscribe((res: ControlPoint[]) => {
        this.tabControlPoints = res;
      })

      this.http.get<Projet[]>('Sites/' + this.utilService.currentSite().siteId + '/Projects').subscribe(resultat => {
        this.tabProjets = resultat;
      }, () => {
        this.fonctionsService.launch_toast(false);

      });
    });
  }

  protected onSubmit(form: any){
    if((!form.valid && form.form) || this.periodeSelectionnee == undefined){
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 1500);
      return;
    }
    this.showIcon = false;

    this.refreshData();
  }

  clearAll() {
    this.rangeStart = null;
    this.rangeEnd = null;
    this.minDate = null;
    this.maxDate = null;
    this.periodeSelectionnee = undefined;
    this.typeTirSelectionnees = [];
    this.lineChartData = null;
  }

  onChangePeriode() {
    let dates: DateInterval = this.fonctionsService.getDateFromPeriode(this.periodeSelectionnee);
    this.rangeStart = new Date(dates.dMin);
    this.rangeEnd = new Date(dates.dMax);
    this.dateChange([this.rangeStart, this.rangeEnd]);
  }

  onDateRangeChanged() {
    if (this.rangeStart && this.rangeEnd) {
      this.dateChange([this.rangeStart, this.rangeEnd]);
      return;
    }
    this.dateChange(null);
  }

  dateChange(e: Date[] | any) {
    if (e && Array.isArray(e) && e.length >= 2) {
      this.minDate = new Date(e[0]).toDateString();
      this.maxDate = new Date(e[1]).toDateString();
    } else {
      this.minDate = null;
      this.maxDate = null;
    }
    if (this.minDate && this.maxDate) {
      this.lineChartData = null;
    }
    this.fetchVibrationData();
  }

  openModalNomGraph() {
    if (this.lineChartData)
      this.modalNomGraph.show();
  }

  save(e: Event | any) {
    e.preventDefault();
    if (!this.lineChartData) return;
    if (this.chartParametre == this.sauvChartParametre) {
      this.modalNomGraph.hide();
      this.modalDejaAjoute.show();
      return;
    }
    
    const target = e.target as HTMLFormElement;
    const inputElement = target.elements.namedItem('nomGraph') as HTMLInputElement;
    const graphName = inputElement ? inputElement.value : '';
    
    let graph = new Graphique();
    graph.nom = graphName;
    graph.type = "Vibration";
    graph.siteId = this.utilService.currentSite().siteId;
    graph.parametre = this.chartParametre;
    graph.utilisateurId = this.keycloakUtilisateurService.userProfile.id;
    
    this.http.post("Chart", graph).subscribe(res => {
      this.sauvChartParametre = this.chartParametre;
      this.modalNomGraph.hide();
      this.fonctionsService.launch_toast(true);
    }, error => {
      this.fonctionsService.loading_screen(false);
    });
  }

  refreshData() {
    this.fetchVibrationData();
  }

  private fetchVibrationData() {
    let controlPointIds = '';
    for (var ctrlPoint of this.ptControlSelectionnes) {
      controlPointIds += ctrlPoint.controlPointId.toString() + ';';
    }

    if (controlPointIds.length > 0) {
      this.chartParametre = 'Vibrations?siteId=' + this.utilService.currentSite().siteId + '&controlPointIdList=' + controlPointIds
        + '&dMin=' + this.minDate + '&dMax=' + this.maxDate + '&periode=' + this.periodeSelectionnee;

      this.http.get('Chart/' + this.chartParametre)
        .subscribe((res: VibrationLineChart[]) => {
          this.lineChartData = {
            datasets: []
          };
          if (null !== res) {
            let datasets = [];
            for (let i = 0; i < res.length; i++) {
              datasets[i] = {
                label: res[i].controlPointName,
                data: res[i].data,
                type: 'line',
                pointHitRadius: 2,
                borderwidth: 2,
                backgroundColor: "transparent",
                pointBackgroundColor:VibrationGraphColors[i] ,
                borderColor: VibrationGraphColors[i] ,
              };

            }
            this.lineChartData.datasets = datasets;
          }

        });
    }
  }
}
